var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    { staticClass: "view-water-insights" },
    [
      _c("ui-heading", {
        attrs: { title: "Water inzichten", icon: "entypo-water" },
      }),
      _vm.waterInsights
        ? _c("ui-panel", [
            _c(
              "div",
              { staticClass: "insights-filters" },
              [
                _c("pm-available-date-picker", {
                  attrs: {
                    date: _vm.selectedDate,
                    availableDates: _vm.waterInsightsDates,
                  },
                  on: {
                    "update:date": function ($event) {
                      _vm.selectedDate = $event
                    },
                  },
                }),
                _c("ui-dropdown", {
                  staticClass: "series-picker",
                  attrs: { options: _vm.waterInsightsSeriesOptions },
                  model: {
                    value: _vm.filter.parcelSeriesId,
                    callback: function ($$v) {
                      _vm.$set(_vm.filter, "parcelSeriesId", $$v)
                    },
                    expression: "filter.parcelSeriesId",
                  },
                }),
              ],
              1
            ),
            _vm.selectedDate
              ? _c("div", { staticClass: "insights-data" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.waterInsightsUrlByDate.get(_vm.selectedDate),
                      alt: `Water inzichten - ${_vm.selectedDate}`,
                    },
                  }),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }